/**
 * tdesign v0.46.2
 * (c) 2022 tdesign
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { defineComponent, ref, reactive, computed, watch, onMounted, onBeforeUnmount } from '@vue/composition-api';
import cloneDeep from 'lodash/cloneDeep';
import '../const.js';
import '../utils/index.js';
import { InputNumber } from '../../input-number/index.js';
import { useBaseClassName } from '../hooks.js';
import useCommonClassName from '../../hooks/useCommonClassName.js';
import baseProps from './base-props.js';
import { GRADIENT_SLIDER_DEFAULT_WIDTH } from '../../_common/js/color-picker/constants.js';
import { genGradientPoint, gradientColors2string } from '../../_common/js/color-picker/color.js';
import '../../_common/js/color-picker/index.js';
import '../../_common/js/color-picker/cmyk.js';
import '../../_common/js/color-picker/draggable.js';
import '@babel/runtime/helpers/classCallCheck';
import '@babel/runtime/helpers/createClass';
import '../../_common/js/color-picker/gradient.js';
import 'tinycolor2';
import '../../input-number/input-number.js';
import '../../_chunks/dep-ca50338e.js';
import 'tdesign-icons-vue';
import '../../button/index.js';
import '../../button/button.js';
import '../../loading/index.js';
import '../../loading/loading.js';
import '../../loading/icon/gradient.js';
import '../../_common/js/loading/circle-adapter.js';
import '../../_common/js/utils/set-style.js';
import '../../_common/js/utils/helper.js';
import '@babel/runtime/helpers/toConsumableArray';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/slicedToArray';
import '../../config-provider/config-receiver.js';
import 'vue';
import 'lodash/mergeWith';
import '../../config-provider/context.js';
import 'lodash/merge';
import '../../_common/js/global-config/default-config.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import '../../config-provider/type.js';
import '../../utils/mixins.js';
import '../../utils/dom.js';
import 'raf';
import 'lodash/isString';
import '../../utils/easing.js';
import '../../utils/render-tnode.js';
import '@babel/runtime/helpers/typeof';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../../utils/transfer-dom.js';
import '../../loading/props.js';
import '../../utils/withInstall.js';
import 'lodash/capitalize';
import './style/css.js';
import '../../loading/type.js';
import '../../loading/plugin.js';
import '../../config.js';
import '../../button/props.js';
import '../../utils/ripple.js';
import '../../button/type.js';
import '../../input/index.js';
import '../../input/input.js';
import '../../utils/helper.js';
import '../../utils/event.js';
import '../../input/props.js';
import '../../input/input-group.js';
import '../../utils/map-props.js';
import '../../input/type.js';
import '../../input-number/props.js';
import '../../input-number/useInputNumber.js';
import '../../hooks/useVModel.js';
import '../../_common/js/input-number/number.js';
import 'lodash/isNumber';
import '../../_common/js/input-number/large-number.js';
import '../../_common/js/log/log.js';
import '../../_common/js/log/index.js';
import '../../hooks/useFormDisabled.js';
import '../../config-provider/useConfig.js';
import '../../hooks/useGlobalIcon.js';
import '../../hooks/useConfig.js';
import '../../input-number/type.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var DELETE_KEYS = ["delete", "backspace"];
var LinearGradient = defineComponent({
  name: "LinearGradient",
  components: {
    TInputNumber: InputNumber
  },
  inheritAttrs: false,
  props: _objectSpread({}, baseProps),
  setup: function setup(props) {
    var baseClassName = useBaseClassName();

    var _useCommonClassName = useCommonClassName(),
        statusClassNames = _useCommonClassName.statusClassNames;

    var refSlider = ref(null);
    var sliderRect = reactive({
      left: 0,
      width: GRADIENT_SLIDER_DEFAULT_WIDTH
    });
    var isDragging = ref(false);
    var isMoved = ref(false);
    var colorInstance = computed(function () {
      return cloneDeep(props.color);
    });
    var degree = ref(colorInstance.value.gradientDegree);
    var selectedId = ref(colorInstance.value.gradientSelectedId);
    var colors = ref(cloneDeep(colorInstance.value.gradientColors));
    watch(function () {
      return props.color.gradientDegree;
    }, function (value) {
      return degree.value = value;
    });
    watch(function () {
      return props.color.gradientSelectedId;
    }, function (value) {
      return selectedId.value = value;
    });
    watch(function () {
      return props.color.gradientColors;
    }, function (value) {
      colors.value = cloneDeep(value);
    }, {
      deep: true
    });

    var handleChange = function handleChange(key, payload, addUsedColor) {
      if (props.disabled) {
        return;
      }

      props.handleChange({
        key: key,
        payload: payload,
        addUsedColor: addUsedColor
      });
    };

    var handleDegreeChange = function handleDegreeChange(value) {
      if (props.disabled || value === colorInstance.value.gradientDegree) {
        return;
      }

      degree.value = value;
      handleChange("degree", value, true);
    };

    var handleSelectedIdChange = function handleSelectedIdChange(value) {
      if (props.disabled) {
        return;
      }

      selectedId.value = value;
      handleChange("selectedId", value);
    };

    var handleColorsChange = function handleColorsChange(value, isEnded) {
      if (props.disabled) {
        return;
      }

      colors.value = value;
      handleChange("colors", value, isEnded);
    };

    var updateActiveThumbLeft = function updateActiveThumbLeft(left) {
      var index = colors.value.findIndex(function (c) {
        return c.id === selectedId.value;
      });

      if (index === -1) {
        return;
      }

      var point = colors.value[index];
      left = Math.max(0, Math.min(sliderRect.width, left));
      var percentLeft = left / sliderRect.width * 100;
      colors.value.splice(index, 1, {
        color: point.color,
        left: percentLeft,
        id: point.id
      });
      handleColorsChange(colors.value);
    };

    var handleStart = function handleStart(id, e) {
      var rect = refSlider.value.getBoundingClientRect();
      sliderRect.left = rect.left;
      sliderRect.width = rect.width || GRADIENT_SLIDER_DEFAULT_WIDTH;

      if (isDragging.value || props.disabled) {
        return;
      }

      isMoved.value = false;
      isDragging.value = true;
      e.preventDefault();
      e.stopPropagation();
      handleSelectedIdChange(id);
      refSlider.value.focus();
      window.addEventListener("mousemove", handleMove, false);
      window.addEventListener("mouseup", handleEnd, false);
      window.addEventListener("contextmenu", handleEnd, false);
    };

    var handleMove = function handleMove(e) {
      if (!isDragging.value || props.disabled) {
        return;
      }

      var left = e.clientX - sliderRect.left;
      isMoved.value = true;
      updateActiveThumbLeft(left);
    };

    var handleEnd = function handleEnd() {
      if (!isDragging.value) {
        return;
      }

      setTimeout(function () {
        isDragging.value = false;
      }, 0);

      if (isMoved.value) {
        handleColorsChange(colors.value, true);
        isMoved.value = false;
      }

      window.removeEventListener("mousemove", handleMove, false);
      window.removeEventListener("mouseup", handleEnd, false);
      window.removeEventListener("contextmenu", handleEnd, false);
    };

    var handleKeyup = function handleKeyup(e) {
      if (props.disabled) {
        return;
      }

      var points = colors.value;
      var pos = points.findIndex(function (c) {
        return c.id === selectedId.value;
      });
      var length = points.length;

      if (DELETE_KEYS.includes(e.key.toLocaleLowerCase()) && length > 2 && pos >= 0 && pos <= length - 1) {
        points.splice(pos, 1);

        if (!points[pos]) {
          pos = points[pos + 1] ? pos + 1 : points[pos - 1] ? pos - 1 : 0;
        }

        var current = points[pos];
        handleColorsChange(points, true);
        handleSelectedIdChange(current === null || current === void 0 ? void 0 : current.id);
      }
    };

    var handleThumbBarClick = function handleThumbBarClick(e) {
      if (props.disabled) {
        return;
      }

      var left = e.clientX - sliderRect.left;
      left = Math.max(0, Math.min(sliderRect.width, left));
      var percentLeft = left / sliderRect.width * 100;
      var newPoint = genGradientPoint(percentLeft, colorInstance.value.rgba);
      colors.value.push(newPoint);
      handleColorsChange(colors.value, true);
      handleSelectedIdChange(newPoint.id);
    };

    onMounted(function () {
      var rect = refSlider.value.getBoundingClientRect();
      sliderRect.left = rect.left;
      sliderRect.width = rect.width || GRADIENT_SLIDER_DEFAULT_WIDTH;
    });
    onBeforeUnmount(function () {
      window.removeEventListener("mousemove", handleMove, false);
      window.removeEventListener("mouseup", handleEnd, false);
      window.removeEventListener("contextmenu", handleEnd, false);
    });
    return {
      baseClassName: baseClassName,
      statusClassNames: statusClassNames,
      refSlider: refSlider,
      degree: degree,
      selectedId: selectedId,
      colors: colors,
      colorInstance: colorInstance,
      handleDegreeChange: handleDegreeChange,
      handleStart: handleStart,
      handleMove: handleMove,
      handleEnd: handleEnd,
      handleKeyup: handleKeyup,
      handleThumbBarClick: handleThumbBarClick
    };
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var _this$colorInstance = this.colorInstance,
        linearGradient = _this$colorInstance.linearGradient,
        gradientColors = _this$colorInstance.gradientColors;
    var colors = this.colors,
        selectedId = this.selectedId,
        degree = this.degree,
        disabled = this.disabled,
        baseClassName = this.baseClassName,
        statusClassNames = this.statusClassNames;
    var thumbBackground = gradientColors2string({
      points: gradientColors,
      degree: 90
    });
    return h("div", {
      "class": "".concat(baseClassName, "__gradient")
    }, [h("div", {
      "class": "".concat(baseClassName, "__gradient-slider")
    }, [h("div", {
      "class": ["".concat(baseClassName, "__slider"), "".concat(baseClassName, "--bg-alpha")],
      "on": {
        "keyup": this.handleKeyup
      },
      "attrs": {
        "tabindex": 0
      },
      "ref": "refSlider"
    }, [h("ul", {
      "class": "gradient-thumbs",
      "on": {
        "click": this.handleThumbBarClick
      },
      "style": {
        background: thumbBackground
      }
    }, [colors.map(function (t) {
      var left = "".concat(Math.round(t.left * 100) / 100, "%");
      return h("li", {
        "class": ["".concat(baseClassName, "__thumb"), "gradient-thumbs__item", selectedId === t.id ? statusClassNames.active : ""],
        "key": t.id,
        "attrs": {
          "title": "".concat(t.color, " ").concat(left)
        },
        "style": {
          color: t.color,
          left: left
        },
        "on": {
          "click": function click(e) {
            return e.stopPropagation();
          },
          "mousedown": function mousedown(e) {
            return _this.handleStart(t.id, e);
          }
        }
      }, [h("span", {
        "class": ["gradient-thumbs__item-inner", "".concat(baseClassName, "--bg-alpha")]
      })]);
    })])])]), h("div", {
      "class": "".concat(baseClassName, "__gradient-degree"),
      "attrs": {
        "title": "".concat(degree, "deg")
      }
    }, [h("t-input-number", {
      "attrs": {
        "theme": "normal",
        "size": "small",
        "min": 0,
        "max": 360,
        "step": 1,
        "format": function format(value) {
          return "".concat(value, "\xB0");
        },
        "disabled": disabled
      },
      "on": {
        "blur": this.handleDegreeChange,
        "enter": this.handleDegreeChange
      },
      "model": {
        value: _this.degree,
        callback: function callback($$v) {
          _this.degree = $$v;
        }
      }
    })]), h("div", {
      "class": ["".concat(baseClassName, "__gradient-preview"), "".concat(baseClassName, "--bg-alpha")]
    }, [h("span", {
      "class": "preview-inner",
      "style": {
        background: linearGradient
      }
    })])]);
  }
});

export { LinearGradient as default };
//# sourceMappingURL=linear-gradient.js.map
